import React, { useEffect, useState } from "react";
import { Formik, FormikConsumer, useFormik } from "formik";
// import * as Yup from "yup";
import {
  TextField,
  Button,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  Box,
} from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import Card from "../../../components/common/Card";
// import { addFuelPurchase } from "../../services/FuelService";
import { toast } from "react-toastify";
import TripDetailsForm from "../../../components/common/TripDetailForm";
import {
  saveDetailsTrips,
  uploadfilesgeneric,
  vehicleListVendors,
} from "../../../services/vehicleService";
import { useDispatch } from "react-redux";
import { setLoader } from "../../../redux/features/authSliceandSidebar";
import { useNavigate } from "react-router-dom";

const fuelTypes = ["Diesel", "Petrol", "Electric"];

const EditDetails = () => {
  const [fuelList, setFuelList] = useState([]);
  const [detailObj, setDetailObj] = useState(null);
  const [key, setKey] = useState(Math.random());
  const [prefilledFields, setPrefilledFields] = useState([]);
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const [singleArray, setSingleArray] = useState([]);
  const [uploadfiles, setUploadfiles] = useState([]);

  const navigate = useNavigate();

  // const  []
  const formik = useFormik({
    initialValues: {
      siteId: null,
      shiftId: null,
      tripDate: null,
      siteIdState: null,
      tripDateState: new Date(),
      vehicleTypeId: null,
      vehicleName: "",
      shiftName: "",
    },
    onReset: (initialValues) => ({
      values: { initialValues },
    }),

    onSubmit: async (values) => {
      // console.log(values);
      let arr = [];

      if (singleArray?.length == 0) {
        toast.error("Atleast one entry is required for submit");
        return;
      }

      if (uploadfiles?.length === 0) {
        toast.error("files are required");
        return;
      }

      singleArray?.forEach((ele) => {
        let formdata = ele;

        formdata["workingHours"] = Number(ele.workingHours);
        arr.push(formdata);
      });
      // console.log(arr);

      let arr1 = arr.map((x) => {
        return {
          ...x,
          ...x.response,

          //   tripDate: formik.values.tripDate + " 00:00:00",
        };
      });

      // console.log(arr1);
      dispatch(setLoader(true));
      await saveDetailsTrips(arr1).then((res) => {
        if (res && res.data.statusDescription.statusCode == 200) {
          toast.success(res.data.statusDescription.description);
          let arr = [];
          if (res.data.tripdetaillog2?.length > 0) {
            res.data.tripdetaillog2.forEach((x) => {
              arr.push(x.tripId);
            });
          }
          if (res.data.tripdetaillog1?.length > 0) {
            res.data.tripdetaillog1.forEach((x) => {
              arr.push(x.tripId);
            });
          }
          // console.log(arr);
          //   resetForms();
          uploadfilesApi(arr);
        } else {
          toast.error(res.data.statusDescription.description);
        }
      });
    },
  });

  const uploadfilesApi = async (arr) => {
    // console.log(arr);
    let formdata = new FormData();

    formdata.append("tripIds", arr.join(","));

    uploadfiles.forEach((x) => {
      formdata.append("files", x);
    });

    // toast.error(uploadfiles.length);

    formdata.append("userId", localStorage.getItem("userId"));
    dispatch(setLoader(true));
    try {
      await uploadfilesgeneric(formdata, "/trip/v1/save-attachments").then(
        (res) => {
          if (res.data.statusDescription.statusCode == 200) {
            // console.log("files saved ");
            dispatch(setLoader(false));
            setUploadfiles([]);
            navigate("/viewTripDetails");
          } else {
            toast.error("Attachment not uploaded");
          }
        }
      );
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("detailsObj") != null) {
      setShowForm(false);
      dispatch(setLoader(true));
      let obj = JSON.parse(localStorage.getItem("detailsObj"));
      console.log(obj);

      EditVendorDetailsApi(obj);

      //   setPrefilledFields(localStorage.getItem("detailObj"));
    }
  }, []);

  const EditVendorDetailsApi = async (details) => {
    console.log(details);
    let formdata = {
      vehicleTypeId: details.vehicleTypeId,
      shiftId: details.shiftId,
      siteId: details.siteId,
      tripDate: details.tripDate,
      fieldCategory: details.vehicleType,
      fieldMenu: "Edit Trip Details",
    };

    await vehicleListVendors(formdata).then((res) => {
      dispatch(setLoader(false));
      if (res && res.data?.statusDescription?.statusCode == 200) {
        console.log(res.data);
        console.log(detailObj);
        setDetailObj(details);
        setKey(Math.random());
        setShowForm(true);
        setPrefilledFields(res.data.portalFields);
      } else {
      }
    });
    console.log(formdata);
  };

  //   useEffect(() => {
  //     if (formik.values.fuelRate && formik.values.fuelQuantity) {
  //       let value = formik.values.fuelRate * formik.values.fuelQuantity;
  //       formik.setFieldValue("totalAmount", value);
  //     }
  //   }, [formik.values.fuelRate, formik.values.fuelQuantity]);

  return (
    <Card title={"Update Trip Details " + detailObj?.tripId}>
      <Box className="container mt-4">
        {showForm && (
          <TripDetailsForm
            key={key}
            prefilled={detailObj}
            editData={detailObj}
            formFields={prefilledFields}
            exportAddition={(e) => {
              console.log(e);
              let arr = [];

              arr.push(e);

              let fileArr = [];

              Object.keys(e).forEach((x) => {
                if (x.includes("file")) {
                  console.log(e[x]);
                  e[x].forEach((fl) => {
                    fileArr.push(fl);
                  });
                  // filearr.push(e[x][0]);
                }
              });

              setUploadfiles(fileArr);

              console.log(e);
              setSingleArray(arr);
              let y;
              formik.handleSubmit(y);
            }}
          />
        )}
      </Box>
    </Card>
  );
};

export default EditDetails;
